import { render, staticRenderFns } from "./UnitPayloadPicture.vue?vue&type=template&id=98fccd54&"
import script from "./UnitPayloadPicture.vue?vue&type=script&lang=js&"
export * from "./UnitPayloadPicture.vue?vue&type=script&lang=js&"
import style0 from "./UnitPayloadPicture.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports